/**
 * Dialog/index.js
 * desc: dialog element
 * note: uses radix-ui/react-popover component
 */
'use strict';

import * as DialogRadix from '@radix-ui/react-dialog';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import { CloseIcon } from "../Icon";
import { classNames } from '../../utilities';
import "./styles.css";

const Dialog = ({ classNameTrigger, classNameContent, children, description="Dialog content", open, onOpen, onInteractOutside, title="Dialog", trigger }) => (
    // `open` is optional: omit it to use the trigger (uncontrolled); pass it (with `onOpen`)
    // to drive the dialog from parent state and render without a trigger.
    <DialogRadix.Root open={ open } onOpenChange={ onOpen }>
        { trigger != null &&
            <DialogRadix.Trigger className={ classNames("component-dialog-trigger", classNameTrigger) } asChild>
                <button>
                    { trigger }
                </button>
            </DialogRadix.Trigger>
        }
        <DialogRadix.Portal>
            <DialogRadix.Overlay className="component-dialog-overlay" />
            <DialogRadix.Content className={ classNames("component-dialog-content", classNameContent) } onInteractOutside={ onInteractOutside }>
                <VisuallyHidden><DialogRadix.Title>{ title }</DialogRadix.Title></VisuallyHidden>
                <VisuallyHidden><DialogRadix.Description>{ description }</DialogRadix.Description></VisuallyHidden>
                { children }
                <DialogRadix.Close asChild>
                    <button className="close-button" aria-label="Close">
                        <CloseIcon className="small" />
                    </button>
                </DialogRadix.Close>
            </DialogRadix.Content>
        </DialogRadix.Portal>
    </DialogRadix.Root>
);


export default Dialog;
